module.exports = __webpack_public_path__ + "MI6dgjSRC-R9mVouC/RDC_RED_Logo_House.svg";